import { FitmentApi } from '@clients/vcfg'
import getBasePath from '@util/path' // eslint-disable-line no-unused-vars

const basePath = getBasePath() + '/vcfg'

export function createFitmentAPIClient (): FitmentApi {
  return new FitmentApi({ basePath })
}
